import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      transform="scale(1.2 1.2)"
      d="M1.52637 5.5233C1.52637 3.75595 2.9627 2.35938 4.69029 2.35938H11.5974H12.441V3.20293V8.60625C12.5538 8.70229 12.6635 8.80352 12.7699 8.90995L13.0576 9.19759L17.9032 14.0432L18.4961 14.6361L17.9068 15.2326C15.7381 17.4274 12.1921 17.4222 10.006 15.2362L9.80742 15.0375C9.2436 15.2914 8.61671 15.4325 7.955 15.4325H2.36992H1.52637V14.5889V14.2997V5.5233ZM11.2043 14.0485C12.5298 15.369 14.5569 15.5415 16.0524 14.5783L12.4409 10.9669C12.4357 12.1658 11.9673 13.2492 11.2043 14.0485ZM8.77378 8.9714C9.472 9.03463 10.1536 9.28326 10.7539 9.722V10.9465C10.7539 11.6875 10.473 12.3568 10.0108 12.855L9.69443 12.5386L6.97372 9.81792C7.47971 9.35012 8.11906 9.06521 8.77378 8.9714ZM5.68836 10.9185L8.46913 13.6993C8.30268 13.7296 8.13085 13.7454 7.955 13.7454H3.74756L5.68836 10.9185ZM10.7539 7.62059C10.1484 7.39762 9.5106 7.28073 8.86989 7.26908L8.82213 7.26821L8.77458 7.27274C8.76039 7.27409 8.74619 7.2755 8.73199 7.27698C8.66142 7.27303 8.59074 7.27039 8.51999 7.26908L8.51218 7.26894H8.50437H8.48224H8.43336L8.38481 7.27459C7.26314 7.40501 6.17421 7.87787 5.31914 8.73294L4.81024 9.24184L4.75528 9.2968L4.71129 9.36088L3.21347 11.5426V5.5233C3.21347 4.70046 3.88166 4.04647 4.69029 4.04647H10.7539V7.62059Z"
      fill={fill}
    />
  </g>
);

export default Icon;
